import { Chargeback } from "@daytrip/legacy-models";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface ChargebackOperatorOptions extends ModelOperatorOptions<Chargeback, null, null> {}

export class ChargebackOperator extends ModelOperator<Chargeback, ChargebackOperatorOptions, null, null, null> {}
